import { ExternalConnection } from '@griply/types';

import { canConnectionWriteEvents } from './can-connection-write-events';

// "Needs reconnect" for the task-sync surfaces means "granted scope can't write events" —
// distinct from `isConnectionBroken`, which is about the OAuth grant itself being dead.
export const getConnectionsNeedingReconnect = (
  connections: ExternalConnection[],
): ExternalConnection[] =>
  connections.filter((connection) => !canConnectionWriteEvents(connection));
